import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DayCampPageOptions } from "../Constants/RegistrationPageOptions";
// import EventCardList from "./EventCardList";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../Components/CheckoutForm";
import DateHelpers from "../Helper/DateHelpers";
import DataAccessHelper from "../Helper/DataAccessHelper";
import '../Styles/DayCampPaymentSuccess.scss';

function ReservationPaymentSuccess() {

   const location = useLocation();
   const navigate = useNavigate();
   const { paymentAmount } = location.state || {};
      console.log("paymentAmount", paymentAmount)

   return(
      <div className="DayCampPaymentSuccessContainer">
         <div className="DayCampPaymentSuccessContent">
            { paymentAmount == 0 &&
               <div className="DayCampPaymentSuccessHeading">
                  Reservation Successful!
               </div>
            }
            { paymentAmount > 0 &&
            <div>
               <div className="DayCampPaymentSuccessHeading">
               Thank You For Your Payment!
               </div>
               <div className="DayCampPaymentSuccessAmount">
               Amount: ${paymentAmount}.00
               </div>
            </div>
            }
            <div className="DayCampPaymentSuccessRedirectButton">
               <button onClick={() =>  navigate('/individualaccount')}>
                  Return to Dashboard
               </button>
            </div>
         </div>
      </div>
   )
}
export default ReservationPaymentSuccess
